import { slotEntity } from "../domain/entities/slot_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n";

export const HttpSlotRepository = {
  model: slotEntity,

  async index() {
    const res = await http.get('apollo/slots');
    
    return res.data.success.arguments.map(item => ({
      ...item,
      actions: JSON.parse(JSON.stringify([
        {
            name: i18n.t('slots.detail'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            method: 'show',
            permission: "slot.show"
        },
        // {
        //     name: i18n.t('slots.edit'),
        //     icon: {
        //         color: 'accent',
        //         icon: 'edit'
        //     },
        //     link: 'slot/edit/' + item.id,
        //     permission: "slot.show"
        // }
      ])),
      parameters: item
    }));
  },
  
  async show(id){
    const res = await http.get('apollo/slot/' + id);
    
    return res.data.success.arguments;
  },

  async create(data) {
    const res = await http.post('apollo/slot/create', data);

    return res;
  }
};